export default __webpack_public_path__ + "static/media/Background 5_00022.77915318.png";